<div class="report-object-status-bar">
  <div class="controls">
    <button
      class="dropdown-selection"
      (click)="openStatusSelector()"
      [disabled]="!(selectStatusCodeList$ | async)?.length"
    >
      <span class="dropdown-selection-text">{{
        selectedStatusCode ? selectedStatusCode.name : ('workOrderObjectHierarchy.selectStatus' | translate)
      }}</span>
      <span class="dropdown-selection-icon"><i class="material-icons icon">arrow_drop_down</i></span>
    </button>
    <div class="progress-input">
      <input
        type="number"
        [min]="lockedProgress$ | async"
        max="100"
        [(ngModel)]="reportProgress"
        (click)="openProgressSlider()"
      />
      %
    </div>
    <button class="cancel-button" (click)="cancel()">
      {{ 'components.confirm.cancel' | translate }}
    </button>
    <button class="apply-button" (click)="submit()" [disabled]="!canSubmit()">
      {{ 'workOrderObject.apply' | translate }} <i class="material-icons icon">done</i>
    </button>
  </div>
</div>
